import { FC } from 'react'
import {
  FacebookCircleFilled,
  InstagramMinimal,
  Link,
  Mail2,
  PhotoFilled,
  YouTube
} from '@dtx-company/shared-components/src'
import { FileOutlined } from '@dtx-company/shared-components/src/foundation/Icons/Flowpage/Widgets/FileUpload'
import { LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'
import { SMSFilled } from '@dtx-company/shared-components/src/foundation/Icons/Everyday/SMSFilled'
import GoogleDocFilled from '@dtx-company/shared-components/src/foundation/Icons/Everyday/GoogleDocFilled/GoogleDocFilled'

export const ScanDestinationIcon: FC<{
  destination: LandingPageDestination
  color?: string
  fill?: string
}> = ({ destination, color = 'currentcolor', fill = 'currentcolor' }) => {
  switch (destination) {
    case LandingPageDestination.WEBSITE:
      return <Link color={color} />
    case LandingPageDestination.FILE:
      return <FileOutlined color={color} />
    case LandingPageDestination.INSTAGRAM:
      return <InstagramMinimal color={color} />
    case LandingPageDestination.SMS:
      return <SMSFilled color={color} />
    case LandingPageDestination.IMAGE:
      return <PhotoFilled color={color} />
    case LandingPageDestination.EMAIL:
      return <Mail2 color={color} />
    case LandingPageDestination.GOOGLE_DOC:
      return <GoogleDocFilled fill={fill} />
    case LandingPageDestination.YOUTUBE:
      return <YouTube color={color} fill={fill} />
    case LandingPageDestination.FACEBOOK:
      return <FacebookCircleFilled color={color} fill={fill} />
    default:
      return <Link color={color} />
  }
}
